import Vue from 'vue';
import VueI18n from 'vue-i18n';
import dateZh from "./src/zh/date.json";
import dateEn from "./src/en/date.json";

Vue.use(VueI18n)

class i18n extends VueI18n {
    constructor() {
        super({
            locale: '',
            message: {},
            fallbackLocale: 'zh',
            dateTimeFormats: {
                zh: dateZh,
                en: dateEn
            }
        })
    }

    async init(config = {}) {
         
        await this.setLocale('zh', config);
        await this.setLocale('en', config);
        this.locale = localStorage.getItem(`${config.VUE_APP_RUN_MODE}_CMS_LANG`) || "zh";
        return this;
    }

    async setLocale(lang, config = {}) {
        const vm = this;
        const loadMessages = async function (lang, config = {}) {
            const messages = {};
            const common = await import(`@/i18n/src/${lang}/common.json`);
            const common_format = vm.formatMessage(common.default, config);

            try {
                const msg = await import(`@/i18n/src/${config.VUE_APP_RUN_MODE}/${lang}.json`);
                const msg_format = vm.formatMessage(msg.default, config);
                Object.assign(messages, msg_format, common_format);
            } catch {
                const msg = await import(`@/i18n/src/${lang}.json`);
                const msg_format = vm.formatMessage(msg.default, config);
                Object.assign(messages, msg_format, common_format);
            }

            return messages;
        }

        const messages = await loadMessages(lang, config);
        this.setLocaleMessage(lang, messages);
    }

    formatMessage(data, config = {}) {
        let d = {};
        if (data !== undefined && data !== null && typeof data === 'object' && Object.keys(data).length) {
            d = JSON.parse(JSON.stringify(data));
            for (let key in d) {
                if (d[`${key}_${config.VUE_APP_RUN_MODE}`]) {
                    d[key] = d[`${key}_${config.VUE_APP_RUN_MODE}`];
                } else if (typeof d[key] === 'object' && Object.keys(d[key]).length) {
                    d[key] = this.formatMessage(d[key], config);
                }
            }
        }

        return d;
    }

}

export default new i18n();